<template>
  <div>
    <data-table :service="JobFollowerService"
                :data="data"
                :local-data="true"
                :entity="entity"
                :go-to-details-on-row-click="false"
                :go-to-add-on-click="false"
                :columns="columns"
                :show-pagination="false"
                :disable-permission-checks="true"
                :title="$t('job.followers.title')"
                operations="add,delete"
                ref="table"
                @on-add="showCreateModal = true"
    >
    </data-table>
    <modal :show.sync="showCreateModal"
           :show-header="false"
           body-classes="p-0"
           class="job-follower-modal"
    >
      <base-form @submit.prevent="createJobFollower"
                 :loading="loading"
                 :show-header="false"
                 :title="$t('job.followers.create')"
      >
        <user-autocomplete v-model="user"
                           class="w-full"
                           :search-params="{'match[client_uuid]': clientId}"
                           :multiple="false"
        />
      </base-form>
    </modal>
  </div>
</template>
<script>
import get from 'lodash/get'
import entities from 'src/config/entities';
import JobFollowerService from 'src/services/JobFollowerService';
import UserAutocomplete from '@/components/Autocomplete/UserAutocomplete'
export default {
  name: 'job-followers',
  components: {
    UserAutocomplete,
  },
  props: {
    data: {
      type: Array,
      default: () => []
    },
    client: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      JobFollowerService,
      entity: entities.JOB_FOLLOWER,
      showCreateModal: false,
      loading: false,
      user: {},
      selectedRow: {}
    }
  },
  computed: {
    columns() {
      return [
        {
          prop: "user_name",
          label: this.$t('generic.name'),
          minWidth: "150px",
          sortable: true
        },
        {
          prop: "user_email",
          label: this.$t('generic.email'),
          minWidth: "150px",
          sortable: true
        }
      ]
    },
    clientId () {
      return get(this.client, 'uuid', '')
    }
  },
  methods: {
    async createJobFollower() {
      try {
        this.loading = true
        const data = {
          user_uuid: this.user.user_uuid,
          job_uuid: this.$route.params.id,
        }
        const follower = await JobFollowerService.create(data)
        this.data.push(follower.data)
        this.showCreateModal = false
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
<style lang="scss">
.job-follower-modal .modal-body > div {
  padding: 0 !important;
}
.job-follower-modal .modal-body .card {
  @apply mb-0;
}
</style>
